import React, { useState } from 'react'
import { TextInput, Button } from "flowbite-react";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import Filter from '../files/Filter';
import Modals from '../../components/Modal';
import LoadingSpinner from '../../components/LoadingSpinner';
import api from '../../lib/api';



const Search = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [modalTitle, setModalTitle] = useState("Buscador de soluciones");
  const [soluciones, setSoluciones] = useState([]);
  const [searchError, setSearchError] = useState("");
  const [dataFilter, setDataFilter] = useState({
    filter: ""
  });
      const [isLoading, setIsLoading] = useState(false);
  const handleSubmitFilter = async() => {

    if(dataFilter.filter == ""){
      alert("Debe ingresar un texto para buscar.");
      return;
    }
    setIsLoading(true);
    setSearchError("");
    try {
      const responseFilter = await api.get('/search/solutions', {
        params: {
          q: dataFilter.filter,
        },
      });

      setSoluciones(Array.isArray(responseFilter.data?.items) ? responseFilter.data.items : []);
      setIsModalOpen(true);



    }catch(error){
      setSoluciones([]);
      setSearchError(error.response?.data?.message || "No fue posible completar la búsqueda.");
      setIsModalOpen(true);
    } finally{
      setIsLoading(false);
    }
  }
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDataFilter({ ...dataFilter, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmitFilter();
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDataFilter({ filter: "" });
    setSearchError("");
  }

  return (
    <>
      {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
      <div className="max-w-md flex">
          <TextInput id="search" type="text" name="filter" onChange={handleInputChange} onKeyDown={handleKeyDown} value={dataFilter.filter}  placeholder="Buscar soluciones" className="w-full mr-3" />
          <Button color="gray" className=" mx-2" onClick={()=>handleSubmitFilter()}>Buscar</Button>
      </div>

      <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"4xl"}>
        <Filter soluciones={soluciones} onClose={closeModal} error={searchError} searchTerm={dataFilter.filter} />
      </Modals>
    </>
  )
}

export default Search

